import { resolveTheme } from "../cjs/tombacCommons";
export const alpha = (color, grade, options) => _ref => {
  let {
    theme
  } = _ref;
  const {
    colors
  } = resolveTheme(theme);
  if (options !== null && options !== void 0 && options.inverted && !colors[color].invertedAlpha) throw new Error(`Color "${color}" does not include inverted alpha palette`);
  return colors[color][options !== null && options !== void 0 && options.inverted ? "invertedAlpha" : "alpha"][grade];
};
export const color = function (color) {
  let grade = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
  return _ref2 => {
    let {
      theme
    } = _ref2;
    return resolveTheme(theme).colors[color][grade];
  };
};
color.black = color("neutral", 900);
color.white = color("neutral", 100);
//# sourceMappingURL=colorTools.js.map